<template>
  <div class="items-center">
    <div class="wait">Logging in. Please wait...</div>
    <progress-loader id="progress-loader" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import decode from 'jwt-decode'
import { UserRoles } from '@ciitizen/component-library'

export default {
  name: 'authenticate-user',
  computed: {
    ...mapState({
      userId: state => state.login.userId
    })
  },
  methods: {
    ...mapActions(['authenticateUser', 'fetchOnboardingSession', 'resumeOnboarding']),
    movetoSummary() {
      this.$router.push(`/${this.userId}/home`)
    },
    uploadRecords() {
      const view = this.$route.query.view
      return view && view == 'upload-records' ? true : false
    },
    checkOnboardingStatus(sessionDetails) {
      this.uploadRecords()
        ? this.$router.push(`/${this.userId}/upload?from=onboarding-upload`)
        : this.resumeOnboarding(sessionDetails)
    },
    async hasOnboardingCompleted() {
      if (this.uploadRecords()) {
        this.$router.push(`/${this.userId}/upload?from=onboarding-upload`)
        return
      }
      if (this.userId) {
        const hasSession = await this.fetchOnboardingSession(this.userId)
        hasSession ? this.checkOnboardingStatus(hasSession) : this.movetoSummary()
      }
    }
  },
  mounted() {
    if (this.$route.query.tkn) {
      const id_token = this.$route.query.tkn
      this.authenticateUser({ id_token })
    } else if (this.$route.query.token && this.$route.params && this.$route.params.userId) {
      const userID = this.$route.params.userId
      const token = this.$route.query.token
      const claim = decode(token)
      if (claim[UserRoles.SOURCE_CLAIM] !== UserRoles.APOLLO) {
        console.error('invalid token')
        throw Error('Unauthorized')
      }

      localStorage.setItem('default_auth_token', token)
      localStorage.setItem('isAdminToken', UserRoles.ADMIN) // keep track of admin login and update apis
      const path = `/${userID}/home`
      this.$router.push({
        path: path
      })
    }
  },
  watch: {
    userId: function () {
      if (this.userId) {
        this.hasOnboardingCompleted()
      }
    }
  }
}
</script>

<style scoped>
.items-center {
  max-width: 100%;
  padding: 0 25%;
}
#progress-loader {
  left: 50%;
}
.wait {
  position: fixed;
  top: 58%;
  width: 100%;
}
@media (min-device-width: 320px) and (max-device-width: 416px) {
  #progress-loader {
    left: 45%;
  }
}
@media (min-device-width: 980px) {
  #progress-loader {
    left: 45%;
  }
}
@media (min-device-width: 768px) and (max-device-width: 950px) {
  .items-center {
    padding: 0 38%;
  }
}
@media (min-device-width: 951px) {
  .items-center {
    padding: 0 14%;
  }
}
</style>
